import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { OverlayTrigger } from 'react-bootstrap';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import Overlay from '../../Miscelania/Overlay';

import LogbookSignatureModal from '../../LogbookAppIntegration/LogbookSignatureModal';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookOccurrencesTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          logbook_app: this.props.logbook_app,
          occurrence_flight: false,
          occurrences: {},
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          aircraft_logbook_flight_id: '',
          abnormal_occurrence_type_id: '',
          coordinates: '',
          location_id: '',
          observations: '',
          occurrence: '',
          date: '',
          legally_interested_contact_type: '',
          staff_key: '',
          staffs: [{ id: 0, name: '', document: '', civil_qualification_type_id: '' }],
          flight_legs_list: [],
          abnormal_occurrence_types_select: [],
          civil_qualification_types_list: [],
          locations_list: [],
          approval_type: '',
          email: '',
          password: '',
          selected_staffs: [],
          staffs_modal: false,
          showLogbookSignatureModal: false,
          signature_modal_title: '',
          signature_modal_subtitle: '',
          signature_modal_confirmation: '',
        };
        this.showStaffsModal = this.showStaffsModal.bind(this);
        this.closeStaffsModal = this.closeStaffsModal.bind(this);
        this.handleStaffChange = this.handleStaffChange.bind(this);
        this.add = this.add.bind(this);
        this.delete = this.delete.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleApproval = this.handleApproval.bind(this);
        this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
        this.addStaffRow = this.addStaffRow.bind(this);
        this.deleteStaffRow = this.deleteStaffRow.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = true;
        } else {
          var value = false;
        }
        change[name] = value;
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            logbook_app: newProps.logbook_app,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.occurrences !== 'undefined' && newProps.occurrences !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            occurrences: newProps.occurrences,
          });
          if (Object.keys(newProps.occurrences).length > 0) {
            this.setState({
              occurrence_flight: true,
            });
          }
        }

        if(typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            flight_legs_list: newProps.flight_legs_list,
          });
        }

        if(typeof newProps.abnormal_occurrence_types_select !== 'undefined' && newProps.abnormal_occurrence_types_select !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            abnormal_occurrence_types_select: newProps.abnormal_occurrence_types_select,
          });
        }

        if(typeof newProps.locations_list !== 'undefined' && newProps.locations_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            locations_list: newProps.locations_list,
          });
        }

        if(typeof newProps.civil_qualification_types_list !== 'undefined' && newProps.civil_qualification_types_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            civil_qualification_types_list: newProps.civil_qualification_types_list,
          });
        }
      }

      // Exibe o modal de pessoas envolvidas
      showStaffsModal(occurrence_id) {
        // Localiza a ocorrência no array de ocorrências
        const occurrence = this.state.occurrences.find(o => o.id === occurrence_id);

        // Extrai o array de staffs e guarda no state
        this.setState({
          selected_staffs: occurrence && occurrence.flight_report_occurrence_staffs 
            ? occurrence.flight_report_occurrence_staffs 
            : [],
          staffs_modal: true,
        });
      }

      // Fecha o modal de pessoas envolvidas
      closeStaffsModal() {
        this.setState({
          selected_staffs: [],
          staffs_modal: false,
        });
      }

      handleStaffChange(index, field, value) {
        const staffs = [...this.state.staffs];
        staffs[index] = { ...staffs[index], [field]: value };
        this.setState({ staffs });
      }

      handleFormSubmit(e) {
        e.preventDefault();
        this.handleApproval('add', null);
      }

      // Após clicar para aprovar o reporte
      handleApproval(type, key) {
        if (type === 'add') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e enviar os dados desta ocorrência anormal para o Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.add();
          }
        }

        if (type === 'delete') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              staff_key: key,
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e enviar o arquivamento desta ocorrência anormal para o Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.delete(key);
          }
        }
      }

      // Após preencher as credenciais do Logbook App
      handleLogbookSignatureSubmit(credentials) {
        // Recebe { email, password } do modal e atualiza o state
        this.setState({
          email: credentials.email,
          password: credentials.password,
          showLogbookSignatureModal: false
        }, () => {
          // Após informar as credenciais, chama a função de aprovação interna
          if (this.state.approval_type === 'add') {
            this.add();
          }
          if (this.state.approval_type === 'delete') {
            this.delete(this.state.staff_key);
          }
        });
      }
    
      // Fetch salvando a edição
      add() {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          aircraft_logbook_flight_id: this.state.aircraft_logbook_flight_id,
          abnormal_occurrence_type_id: this.state.abnormal_occurrence_type_id,
          observations: this.state.observations,
          coordinates: this.state.coordinates,
          location_id: this.state.location_id,
          occurrence: this.state.occurrence,
          date: this.state.date,
          legally_interested_contact_type: this.state.legally_interested_contact_type,
          staffs: this.state.staffs,
          email: this.state.email,
          password: this.state.password,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/ocorrencia/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
              self.setState({
                aircraft_logbook_flight_id: '',
                abnormal_occurrence_type_id: '',
                coordinates: '',
                location_id: '',
                observations: '',
                occurrence: '',
                date: '',
                legally_interested_contact_type: '',
                staffs: [{ id: 0, name: '', document: '', civil_qualification_type_id: '' }],
                email: '',
                password: '',
              });
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      delete (id) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var datasave = {
          id: id,
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          email: this.state.email,
          password: this.state.password,
        };
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/ocorrencia/logbook', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              email: '',
              password: '',
            });
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      addStaffRow() {
        const newKey = this.state.staff_key + 1;
        var staff = {
          id: newKey,
          name: '',
          document: '',
          civil_qualification_type_id: ''
        };
        this.setState({
          staffs: this.state.staffs.concat([staff]),
          staff_key: newKey,
        });
      }

      deleteStaffRow(id) {
        var staffs = this.state.staffs;
        staffs = staffs.filter(function(staff) {
          return staff.id !== id;
        });
        this.setState({
          staffs: staffs,
        });
      }
    
      render() {
        var self = this;
        return (
        <div>
          <RequestApi ref={'request_api'} />
          <Overlay overlay={this.state.overlay} handleAlert={this.props.handleAlert} />
          <div className='row'>
            <div className='col-md-1'>
              <Toggle
                checked={this.state.occurrence_flight}
                aria-label='No label tag'
                name="occurrence_flight"
                onChange={this.handleToggleChange.bind(this, 'occurrence_flight')}
              />
            </div>
            <div className='col-md-11'>
              <h3 className="page-title pull-left">Occurrences In Flight</h3>
              <div className="clearfix"></div>
            </div>
          </div>
          {this.state.occurrence_flight == true &&
            <div>
              <hr/>
              <form onSubmit={this.handleFormSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Flight Leg</label>
                      <Select
                        className="form-group"
                        name="aircraft_logbook_flight_id"
                        value={this.state.aircraft_logbook_flight_id}
                        searchable={true}
                        placeholder={'Selecionar trecho'}
                        onChange={this.handleSelectChange.bind(this, 'aircraft_logbook_flight_id')}
                        options={this.state.flight_legs_list}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Type</label>
                      <br/>
                      <Select
                        className="form-group"
                        name="abnormal_occurrence_type_id"
                        value={this.state.abnormal_occurrence_type_id}
                        searchable={true}
                        placeholder={'Selecionar tipo'}
                        onChange={this.handleSelectChange.bind(this, 'abnormal_occurrence_type_id')}
                        options={this.state.abnormal_occurrence_types_select}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Location</label>
                      <br/>
                      <Select
                        className="form-group"
                        name="location_id"
                        value={this.state.location_id}
                        searchable={true}
                        placeholder={'Selecionar localidade'}
                        onChange={this.handleSelectChange.bind(this, 'location_id')}
                        options={this.state.locations_list}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Coordinates</label>
                      <br/>
                      <input type="text" className="form-control" value={this.state.coordinates} name="coordinates" onChange={this.handleChange.bind(this, 'coordinates')} placeholder="Coordenadas" required />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Date</label>
                      <br/>
                      <InputMask value={this.state.date} name="date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={'dd/mm/aaaa hh:mm'} required />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Contact Type</label>
                      <br/>
                      <input type="text" className="form-control" value={this.state.legally_interested_contact_type} name="legally_interested_contact_type" onChange={this.handleChange.bind(this, 'legally_interested_contact_type')} placeholder="Meio de contato do interessado" required />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Occurrence</label>
                      <br/>
                      <input type="text" className="form-control" value={this.state.occurrence} name="occurrence" onChange={this.handleChange.bind(this, 'occurrence')} placeholder="Ocorrência" required />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Description</label>
                      <br/>
                      <input type="text" className="form-control" value={this.state.observations} name="observations" onChange={this.handleChange.bind(this, 'observations')} placeholder="Descrição" required />
                    </div>
                  </div>
                </div>
                <hr/>
                <h4>Personnel Involved</h4>
                <table className="table table-bordered table-hover table-striped">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Document</th>
                      <th>Civil Qualification</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody id="staffs">
                  {self.state.staffs.map(function(staff, idx) {
                    return(
                    <tr className="text-center" key={staff.id}>
                      <td>
                        <input type="text" className="form-control" value={staff.name} onChange={e => self.handleStaffChange(idx, 'name', e.target.value)} placeholder="Nome" required />
                      </td>
                      <td>
                        <input type="text" className="form-control" value={staff.document} onChange={e => self.handleStaffChange(idx, 'document', e.target.value)} placeholder="Documento" required />
                      </td>
                      <td>
                        <Select
                          className="form-group"
                          value={self.state.civil_qualification_types_list.find(o => o.value === staff.civil_qualification_type_id) || null}
                          searchable={true}
                          placeholder={'Selecionar qualificação civil'}
                          onChange={opt => self.handleStaffChange(idx, 'civil_qualification_type_id', opt ? opt.value : null)}
                          options={self.state.civil_qualification_types_list}
                          required
                        />
                      </td>
                      <td>
                        <div>
                          <button type="button" onClick={() => {self.deleteStaffRow(staff.id)}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
                          {/* Se for o último, exibe o botão para adicionar mais um campo */}
                          {idx === self.state.staffs.length - 1 && (
                            <button type="button" onClick={self.addStaffRow} className="btn btn-success btn-sm button-inline"><i className="fa fa-plus"></i></button>
                          )}
                        </div>
                      </td>
                    </tr>
                    );
                  })}
                  </tbody>
                </table>
                <hr/>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
                    </div>
                  </div>
                </div>
              </form>
              <hr/>
              <div className="table-responsive">
                <table className="table table-bordered table-hover table-striped">
                  <caption>Occurrences</caption>
                  <thead>
                    <tr>
                      <th>Flight Leg</th>
                      <th>Type</th>
                      <th>Location</th>
                      <th>Coordinates</th>
                      <th>Date</th>
                      <th>Contact Type</th>
                      <th>Occurrence</th>
                      <th>Description</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody id="occurrences">
                  {Object.keys(self.state.occurrences).map(function(k) {
                    var occurrence = self.state.occurrences[k];
                    return(
                    <tr className="text-center" key={occurrence.id}>
                      <td>{occurrence.leg}</td>
                      <td>{occurrence.abnormal_occurrence_type.type}</td>
                      <td>{occurrence.location.icao_code}</td>
                      <td>{occurrence.coordinates}</td>
                      <td>{occurrence.date_str}</td>
                      <td>{occurrence.legally_interested_contact_type}</td>
                      <td>{occurrence.occurrence}</td>
                      <td>{occurrence.observations}</td>
                      <td>
                        <div className="btn-group">
                          <button onClick={() => {self.showStaffsModal(occurrence.id)}} className="btn btn-info btn-sm button-inline"><i className="fa fa-eye"></i></button>
                          <button onClick={() => {self.handleApproval('delete', occurrence.id)}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
                        </div>
                      </td>
                    </tr>
                    );
                  })}
                  </tbody>
                </table>
              </div>
            </div>
          }
          {/* Modal de assinatura do LogbookApp */}
          <LogbookSignatureModal
            show={this.state.showLogbookSignatureModal}
            onHide={() => this.setState({ showLogbookSignatureModal: false })}
            onSubmit={this.handleLogbookSignatureSubmit}
            title={this.state.signature_modal_title}
            subtitle={this.state.signature_modal_subtitle}
            confirmation={this.state.signature_modal_confirmation}
          />
          {/* Modal de pessoas envolvidas */}
          <Modal show={this.state.staffs_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
            <Modal.Header>
              <h4 className="pull-left">Personnel Involved</h4>
              <button className="btn btn-danger btn-sm pull-right" onClick={this.closeStaffsModal}>
                <i className="fa fa-fw fa-close"></i>
              </button>
              <div className="clearfix"></div>
            </Modal.Header>

            <Modal.Body>
              <div className="table-responsive">
                <table className="table table-bordered table-hover table-striped">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Document</th>
                      <th>Civil Qualification</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.selected_staffs.length > 0 ? (
                      this.state.selected_staffs.map(staff => (
                        <tr className="text-center" key={staff.id}>
                          <td>{staff.name}</td>
                          <td>{staff.document}</td>
                          <td>
                            {staff.civil_qualification_type
                              ? staff.civil_qualification_type.description
                              : ''}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No personnel found for this occurrence.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button className="btn btn-danger btn-sm pull-right" onClick={this.closeStaffsModal}>
                <i className="fa fa-fw fa-close"></i>
              </button>
            </Modal.Footer>
          </Modal>
        </div>
    );
  }
}

export default AircraftLogbookOccurrencesTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookOccurrencesTab.js